import { useCallback } from "react";
import { useToast } from "contexts/ToastContext";
import { shareFile, type ShareFileOptions } from "utils/share";

export const useShareFile = () => {
  const { showError } = useToast();

  return useCallback(
    async (options: ShareFileOptions) => {
      try {
        await shareFile(options);
      } catch (error) {
        if (!(error instanceof DOMException && error.name === "AbortError")) {
          showError("Failed to share file. Please try again.");
        }
      }
    },
    [showError],
  );
};
